import React from 'react';
import { BabyIcon, HeartPulseIcon, PillIcon, SparklesIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
type Goal = {
  title: string;
  description: string;
  icon: React.ElementType;
  href: string;
  tone: string;
};
const goals: Goal[] = [{
  title: 'Everyday care',
  description: 'Personal care essentials',
  icon: SparklesIcon,
  href: '/category/personal-care?from=now',
  tone: 'bg-[#fff1f2] text-[#c83f5b]'
}, {
  title: 'Health & energy',
  description: 'Vitamins, wellness & more',
  icon: HeartPulseIcon,
  href: '/category/vitamins-supplements?from=now',
  tone: 'bg-[#eef9f8] text-[#16726c]'
}, {
  title: 'Family care',
  description: 'Baby and family essentials',
  icon: BabyIcon,
  href: '/category/baby-mother?from=now',
  tone: 'bg-[#fff6e7] text-[#a75b13]'
}, {
  title: 'Pharmacy now',
  description: 'Medicine and urgent needs',
  icon: PillIcon,
  href: '/category/medicines?from=now',
  tone: 'bg-[#eef4ff] text-[#4169ad]'
}];
export function NowGoalSelector() {
  const navigate = useNavigate();
  return <section className="mx-auto max-w-7xl px-4 pt-7 md:px-6 md:pt-10" aria-labelledby="now-goals-heading" data-id="element-4424" data-mp="1r1thrz6njdgu">
    <div className="flex items-end justify-between gap-4" data-id="element-4425" data-mp="1m52zd57dk5s9"><div data-id="element-4426" data-mp="1hctei3l49vwu"><p className="text-xs font-bold uppercase tracking-[0.13em] text-[#e6325c]" data-id="element-4427" data-mp="1hctgg94og5zh">Shop with purpose</p><h2 id="now-goals-heading" className="mt-1 text-xl font-bold text-gray-900 md:text-2xl" data-id="element-4428" data-mp="1dbpy9fz5pxv3">Choose your goal</h2><p className="mt-1 text-sm text-gray-600" data-id="element-4429" data-mp="18cwjlk84w0tc">Start with what you need, right when you need it.</p></div></div>
    <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-4430" data-mp="13d0qig0z5tsk">{goals.map(goal => {
        const Icon = goal.icon;
        return <button key={goal.title} type="button" onClick={() => navigate(goal.href)} className="group flex min-h-[132px] flex-col items-start rounded-2xl border border-gray-200 bg-white p-4 text-left transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-0.5 hover:border-[#a5d6d1] hover:shadow-[0_8px_18px_rgba(25,84,79,0.08)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#16726c] focus-visible:ring-offset-2" data-id="element-4431" data-mp="yf8napuvql92"><span className={`flex h-10 w-10 items-center justify-center rounded-xl ${goal.tone}`} data-id="element-4432" data-mp="m24w5yqbwhnk"><Icon className="h-5 w-5" aria-hidden="true" data-id="element-4433" data-mp="qwraoarpiqbv" /></span><span className="mt-4 text-sm font-bold text-gray-900" data-id="element-4434" data-mp="d42sfbf7nawl">{goal.title}</span><span className="mt-1 text-xs leading-4 text-gray-600" data-id="element-4435" data-mp="h4ll17oxgkzu">{goal.description}</span></button>;
      })}</div>
  </section>;
}